export default "__VITE_ASSET__CkCC3iGk__"